// extracted by mini-css-extract-plugin
module.exports = {"root":"IconBolt_root__2elB4"};